import { isActive, type UploadEntry } from '../uploads/store'
import { formatBytes } from '../utils/format'
import { Button, ProgressBar } from './ui'

function describe(entry: UploadEntry): string {
  switch (entry.phase) {
    case 'starting':
      return 'Preparing the upload…'
    case 'uploading': {
      const seconds = (Date.now() - entry.startedAt) / 1000
      const rate = seconds > 1 ? ` · ${formatBytes(entry.sent / seconds)}/s` : ''
      return `${formatBytes(entry.sent)} of ${formatBytes(entry.size)}${rate}`
    }
    case 'finishing':
      return 'Finishing the upload…'
    case 'done':
      return 'Uploaded. Processing has started.'
    case 'cancelled':
      return 'Upload cancelled.'
    case 'failed':
      return entry.error ?? 'The upload failed.'
  }
}

export function UploadProgress({ entry, onCancel }: { entry: UploadEntry; onCancel?: () => void }) {
  const percent = entry.size > 0 ? (entry.sent / entry.size) * 100 : 0
  const tone = entry.phase === 'failed' ? 'danger' : entry.phase === 'done' ? 'ok' : 'accent'
  return (
    <div className="stack-sm" data-testid="upload-progress">
      <div className="row between">
        <strong className="truncate">{entry.filename}</strong>
        <span className="muted small">{Math.floor(percent)}%</span>
      </div>
      <ProgressBar value={percent} tone={tone} label="Upload progress" />
      <div className="row between small">
        <span className={entry.phase === 'failed' ? 'error-text' : 'muted'}>{describe(entry)}</span>
        {isActive(entry) && onCancel && (
          <Button variant="ghost" onClick={onCancel}>Cancel</Button>
        )}
      </div>
    </div>
  )
}
